const createClusterMarkerHtml = (size: number): string => {
	const fontSize = Math.round(size * 0.35);

	return `
		<div style="display:flex;align-items:center;justify-content:center;width:${size}px;height:${size}px;border-radius:50%;background:rgba(255,195,66,0.7);color:white;font-size:${fontSize}px;font-weight:600;box-shadow:0 2px 8px rgba(0,0,0,0.2);">
			<span></span>
		</div>
	`;
};

export default createClusterMarkerHtml;
